import styled from 'styled-components'

import { H2 } from '@ui/blocks/Heading'
import { Container } from '@ui/blocks/Container'

import { ARTICLE_WIDTH } from './Article'

export const StyledContainer = styled(Container)`
  margin-bottom: 6.4rem;

  @media ${({ theme }) => theme.device.tablet} {
    margin-bottom: 3.5rem;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    margin-bottom: 2.4rem;
  }
`

export const ArticlesList = styled.section`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  &::after {
    width: ${ARTICLE_WIDTH};
    content: '';
  }
`

export const Title = styled(H2)`
  margin-bottom: 4rem;

  @media ${({ theme }) => theme.device.tablet} {
    margin-bottom: 3.2rem;
  }
`

export const ArticlesListMobile = styled.div`
  display: none;

  &&& .swiper-slide {
    width: 37rem;
  }

  @media ${({ theme }) => theme.device.tablet} {
    display: block;
  }

  @media ${({ theme }) => theme.device.mobileL} {
    &&& .swiper-slide {
      width: 25.2rem;
    }
  }
`

export const ArticlesListDesktop = styled.div`
  @media ${({ theme }) => theme.device.tablet} {
    display: none;
  }
`
